/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Birth_TitleInputs */

const en_us2_profile_editors_birth_title = /** @type {(inputs: Profile_Editors_Birth_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When were you born?`)
};

const pt_br2_profile_editors_birth_title = /** @type {(inputs: Profile_Editors_Birth_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando você nasceu?`)
};

const es_419_profile_editors_birth_title = /** @type {(inputs: Profile_Editors_Birth_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuándo naciste?`)
};

const pt_pt2_profile_editors_birth_title = /** @type {(inputs: Profile_Editors_Birth_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando nasceste?`)
};

const fr_fr2_profile_editors_birth_title = /** @type {(inputs: Profile_Editors_Birth_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quand es-tu né ?`)
};

const de_de2_profile_editors_birth_title = /** @type {(inputs: Profile_Editors_Birth_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wann bist du geboren?`)
};

const it_it2_profile_editors_birth_title = /** @type {(inputs: Profile_Editors_Birth_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando sei nato?`)
};

/**
* | output |
* | --- |
* | "When were you born?" |
*
* @param {Profile_Editors_Birth_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_birth_title = /** @type {((inputs?: Profile_Editors_Birth_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Birth_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_birth_title(inputs)
	if (locale === "es-419") return es_419_profile_editors_birth_title(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_birth_title(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_birth_title(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_birth_title(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_birth_title(inputs)
	return en_us2_profile_editors_birth_title(inputs)
});
export { profile_editors_birth_title as "profile-editors.birth_title" }